// extracted by mini-css-extract-plugin
export default {"root":"Terms_root__fz+TP","link":"Terms_link__4L+by","Terms":"Terms_Terms__5zE92"};